import React from "react";
import Link from "next/link";
import classNames from "classnames";

interface TopbarAuctionPaginationProps {
  sortedItems: { itemSortNo: number; itemId: number }[];
  currentItemSortNo: number;
  onNavigate?: (newSortNo: number) => void; // Optional, in case you need extra logic on navigate
  getAuctionItemLink: (item: { itemId: number }) => string;
}

const TopbarAuctionPagination: React.FC<TopbarAuctionPaginationProps> = ({
  sortedItems,
  currentItemSortNo,
  getAuctionItemLink,
}) => {
  const currentIndex = sortedItems.findIndex(
    (item) => item.itemSortNo === currentItemSortNo
  );

  const hasPrevious = currentIndex > 0;
  const hasNext = currentIndex < sortedItems.length - 1;

  const previousItem = hasPrevious ? sortedItems[currentIndex - 1] : null;
  const nextItem = hasNext ? sortedItems[currentIndex + 1] : null;

  const IconArrow = ({ direction }: any) => (
    <svg
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      className={classNames("text-white w-4 h-4", {
        "rotate-180": direction == "right",
        "pointer-events-none right": direction == "right",
        "pointer-events-none left": direction == "left",
      })}
    >
      <path
        d="M15.7051 7.70443L11.1251 12.2944L15.7051 16.8844L14.2951 18.2944L8.29512 12.2944L14.2951 6.29443L15.7051 7.70443Z"
        fill="currentColor"
      />
    </svg>
  );

  return (
    <div className="flex items-center justify-center space-x-4">
      {hasPrevious ? (
        <Link
          href={getAuctionItemLink(previousItem!)}
          className="p-2 bg-blue text-white rounded hover:bg-blue-600"
          prefetch={false}
        >
          <IconArrow direction="left" />
        </Link>
      ) : (
        <button
          disabled
          className="p-2 bg-gray-300 text-gray-500 rounded cursor-not-allowed"
        >
          <IconArrow direction="left" />
        </button>
      )}

      <span className="text-lg font-semibold">Rop {currentItemSortNo}</span>

      {hasNext ? (
        <Link
          href={getAuctionItemLink(nextItem!)}
          className="p-2 bg-blue text-white rounded hover:bg-blue-600"
          prefetch={false}
        >
          <IconArrow direction="right" />
        </Link>
      ) : (
        <button
          disabled
          className="p-2 bg-gray-300 text-gray-500 rounded cursor-not-allowed"
        >
          <IconArrow direction="right" />
        </button>
      )}
    </div>
  );
};

export default TopbarAuctionPagination;
